import { useState, useEffect } from 'react'
import styles from '../../../pages/LeadCapture/ExhibitorConfig/ExhibitorConfig.module.css'
// Font Awesome assets
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencil, faSquareCheck, faTrashCan, faSquareXmark } from '@fortawesome/free-solid-svg-icons'

// image elements
const pencil = <FontAwesomeIcon icon={faPencil} />
const trash = <FontAwesomeIcon icon={faTrashCan} />
const squareCheck = <FontAwesomeIcon icon={faSquareCheck} />
const squareXmark = <FontAwesomeIcon icon={faSquareXmark} />
const LCProductOrder = ({ index, productOrderItem, editProductOrder, deleteProductOrder, cancelEdit, submitEdit, editingId, attachments }) => {

    const [formData, setFormData] = useState(
        {
            id: null,
            quantity: 0,
            selected: false,
            purchasePrice: 0,
            promoCode: null,
            cancelled: false,
            isAdmin: false,
            total: 0,
        }
    )
    const isEditInvalid = () => {
        return !(formData.purchasePrice !== undefined && formData.quantity !== undefined);
    }
    const submitEditChange = async e => {
        e.preventDefault()
        submitEdit(e, formData);
    }
    function base64ToBlob(base64Data, contentType = 'application/pdf') {
        const byteCharacters = atob(base64Data.split(',')[1]);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += 512) {
            const slice = byteCharacters.slice(offset, offset + 512);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        return new Blob(byteArrays, { type: contentType });
    }
    function createObjectURLfromBase64(base64String, contentType) {
        const blob = base64ToBlob(base64String, contentType);
        return URL.createObjectURL(blob);
    }
    const limitText = (strText, lenLimit) => {
        let result = ''
        if (strText && strText.length > lenLimit) {
            result = strText.substring(0, lenLimit);
            result += '...';
        }
        else {
            result = strText;
        }
        return result;
    }
    const generatePDF = ( attachment) => {
        var foundAttachment = attachments.find((item) => item.fileName === attachment);
        if (foundAttachment) {
            let newPDF = createObjectURLfromBase64(foundAttachment.attachmentBase64, foundAttachment.fileType);
            window.open(newPDF); 
        }
        else {
            return null
        }

    }
    const handleChange = (e) => {
        if (e.target.type === 'number') {
            formData[e.target.name] = parseInt(e.target.value);
            setFormData({
                ...formData
            })
        }
        else if (e.target.type === 'checkbox') {
            formData[e.target.name] = e.target.checked;
            if (e.target.name === 'selected') {
                if (e.target.checked) {
                    formData.quantity = 1;
                }
                else {
                    formData.quantity = 0;
                }
            }
            
            setFormData({
                ...formData
            })
        }
        else {
            formData[e.target.name] = e.target.value;
            setFormData({
                ...formData
            })
        }
    }
    const calculateTotal = () => {
        let total = 0;
        total = formData.quantity * formData.purchasePrice;
        if (total > 0) {
            formData.total = total;
            setFormData({
                ...formData
            })
        }
        else {
            formData.total = 0;
            setFormData({
                ...formData
            })
        }
    }
    useEffect(() => {
        if (formData.quantity && formData.quantity !== undefined) {
            calculateTotal();
        }
    }, [formData.quantity])
    useEffect(() => {
        if (productOrderItem) {
            let productOrder = {
                i: productOrderItem.id,
                quantity: productOrderItem.quantity ? productOrderItem.quantity : 0,
                purchasePrice: productOrderItem.purchasePrice ? productOrderItem.purchasePrice : 0,
                promoCode: productOrderItem.promoCode ? productOrderItem.productCode : null,
                cancelled: productOrderItem.cancelled ? productOrderItem.cancelled : false,
                isAdmin: productOrderItem.isAdmin ? productOrderItem.isAdmin : false,
                total: productOrderItem.quantity && productOrderItem.purchasePrice ? productOrderItem.quantity * productOrderItem.purchasePrice : 0,
            };
            setFormData(productOrder);
        }
    }, [editingId])
    return (
        <>
            {editingId !== index.toString() ?
                <tr className={styles.trProducts} >
                    <td className={styles.tdProducts}> {productOrderItem.skuName}</td>
                    <td className={styles.tdProducts}> {productOrderItem.name}</td>
                    <td className={styles.tdProducts}> {limitText(productOrderItem.description, 110)}</td>
                    <td className={styles.tdProducts}> {productOrderItem.purchasePrice}</td>
                    <td className={styles.tdProducts}> {productOrderItem.showQuantity && productOrderItem.showQuantity !== undefined ? productOrderItem.quantity :
                        productOrderItem.quantity === 1 ? 'Yes' : 'No'}</td>
                    <td className={styles.tdProducts}> 
                        <a title={productOrderItem.pdfAttachment} className={styles.pdfLink}
                            onClick={() => generatePDF(productOrderItem.pdfAttachment)}>{limitText(productOrderItem.pdfAttachment, 16)}</a>
                    </td>
                    <td className={styles.tdProducts}> {productOrderItem.usePromoCode && productOrderItem.usePromoCode !== undefined && productOrderItem.usePromoCode ? productOrderItem.promoCode : "N/A"}</td>
                    <td className={styles.tdProducts}> {productOrderItem.cancelled && productOrderItem.cancelled !== undefined && productOrderItem.cancelled ? "Yes" : "No"}</td>
                    <td className={styles.tdProducts}>
                        <button className={styles.editButton} onClick={e => editProductOrder(e)} id={index} title="Edit product.">
                            <i className={styles.buttonImage}>{pencil}</i>
                        </button>
                        {/*<button className={styles.editButton} onClick={e => deleteProductOrder(e)} id={index} title="Delete product.">*/}
                        {/*    <i className={styles.buttonImage}>{trash}</i>*/}
                        {/*</button>*/}
                    </td>
                </tr>
                :
                <tr className={styles.trProducts} >
                    <td className={styles.tdProducts}>
                        {productOrderItem.skuName}</td>
                    <td className={styles.tdProducts}>
                        {productOrderItem.name}
                    </td>
                    <td className={styles.tdProducts}>
                        {limitText(productOrderItem.description, 110)}
                    </td>
                    <td className={styles.tdProducts}>
                        <input
                            tabIndex='12'
                            type="number"
                            value={formData.purchasePrice}
                            name="purchasePrice"
                            onChange={handleChange}
                            className={styles.fitCell}
                        />
                    </td>
                    {
                        productOrderItem.showQuantity && productOrderItem.showQuantity === true ?
                            <td className={styles.tdProducts}>
                                <input
                                    tabIndex= '13'
                                    type="number"
                                    value={formData.quantity}
                                    name="quantity"
                                    onChange={handleChange}
                                    className={styles.fitCell}
                                />
                            </td>
                        : 
                            <input
                                tabIndex='13'
                                type="checkbox"
                                checked={formData.selected}
                                name="selected"
                                onChange={handleChange}
                                className={styles.fitCell}
                            />
                    }
                   
                    <td className={styles.tdProducts}>
                        <a title={productOrderItem.pdfAttachment} className={styles.pdfLink}
                            onClick={() => generatePDF(productOrderItem.pdfAttachment)}>{limitText(productOrderItem.pdfAttachment, 16)}</a>
                    </td>

                    <td className={styles.tdProducts}>
                        {productOrderItem.usePromoCode && productOrderItem.usePromoCode !== undefined && productOrderItem.usePromoCode ?
                            <input
                                tabIndex='14'
                                type="number"
                                value={formData.promoCode}
                                name="promoCode"
                                onChange={handleChange}
                                className={styles.fitCell}
                            /> :
                            <label >
                                 N/A
                            </label>
                        }
                    </td>
                    <td className={styles.tdProducts}>
                        <input
                            tabIndex='15'
                            type="checkbox"
                            checked={formData.cancelled}
                            name="cancelled"
                            onChange={handleChange}
                            className={styles.fitCell}
                        />
                    </td>
                    
                    <td className={styles.tdAccounts}>
                        <button onClick={e => cancelEdit(e)} id={index} className={styles.editButtons} title="Cancel Edit">
                            <i className={styles.buttonImage} id={styles.editCancel}>
                                {squareXmark}
                            </i>
                        </button>
                        <button onClick={e => submitEditChange(e)} id={index} className={styles.editButtons} disabled={isEditInvalid()} title="Submit Edit">
                            <i className={styles.buttonImage} id={styles.editSubmit}>
                                {squareCheck}
                            </i>
                        </button>
                    </td>
                </tr>
            }
        </>
    );
}

export default LCProductOrder;